import type { Service } from '../services/service'

export class TaxInvoiceServiceEntity {
    serviceId?: string
    description: string
    code: string
    iss: TaxInvoiceServiceISSEntity
    taxCode: string
    codigoContribuinte: string
    cnae: string
    nbs: string
    value: TaxInvoiceServiceValueEntity
    service?: Service
    codigoCidadeIncidencia: string
    codigoServicoNacional: string
    ibscbs: TaxInvoiceServiceIBSCBSInputDto
}

export class TaxInvoiceServiceISSEntity {
    taxRate: number
    taxSituation: number
}

export class TaxInvoiceServiceValueEntity {
    grossValue: number
}

export class TaxInvoiceServiceIBSCBSInputDto {
    constructor() {
        this.valores = {
            tributacao: {
                cst: '',
                cct: '',
            },
        }
    }
    finalidadeNFSe: number // 0 = normal
    operacaoPessoal: number // 0 = não / 1 = sim // operação pessoal é quando origem e destino é a mesma empresa
    codigoOperacao: string // Código indicador da operação de fornecimento, conforme tabela 'código indicador de operação'.
    //tipoOperacao: number // para entes governamentais. provavelmente nunca será informado
    //indicadorOperacao: boolean //  se a operação é onerosa ou não (como doações)
    valores: {
        tributacao: {
            cst: string // Código de Situação Tributária (CST).
            cct: string // Código de Classificação de Tributação (CCT).
        }
    }
}
